import React, { lazy } from 'react';
const OrderOperatorsDashboard = lazy(() => import('../containers/OrderOperators/OrderOperatorsDashboard'));
function OrderOperatorsRouts() {
    return React.createElement(OrderOperatorsDashboard, null);
}
export default OrderOperatorsRouts;
